import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBoardMenuFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.935 10.145h-4.31a.75.75 0 0 1 0-1.5h4.31a.75.75 0 0 1 0 1.5m0 5.208h-4.31a.75.75 0 0 1 0-1.5h4.31a.75.75 0 0 1 0 1.5M8.37 10.145h-.305a.75.75 0 0 1 0-1.5h.305a.75.75 0 0 1 0 1.5m0 5.208h-.305a.75.75 0 0 1 0-1.5h.305a.75.75 0 0 1 0 1.5M16.217 2.5H7.783C4.623 2.5 2.5 4.721 2.5 8.026v7.948c0 3.305 2.123 5.526 5.283 5.526h8.433c3.16 0 5.284-2.221 5.284-5.526V8.026c0-3.305-2.123-5.526-5.283-5.526"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBoardMenuFilled);
export default ForwardRef;
